import { removeLocalStorage, removeSessionStorage } from "./localStorage"

export const removeNonAsciiChars = (str) => {
  return str ? str.replace(/[^\x20-\x7E]/g, '') : ''
}

export const navToLogin = () => {
  removeLocalStorage('auth')
  removeSessionStorage('auth')
  removeLocalStorage('session_id')
  window.location = '/'
}